jQuery(document).ready(function ($) {
  adjustForm();

  function adjustForm() {
    const $form = $($('.elementor-location-footer .elementor-form')[0]);
    if (!$form.length) {
      return;
    }
    const $input = $form.find('input[type=email]');
    const $submitButton = $form.find('button[type=submit]');
    $input.after('<div class="klaviyo-dummy-submit"></div>');
    const $dummySubmit = $('.klaviyo-dummy-submit');

    $input.on('change', setDummySubmitClass);
    $input.on('keyup', setDummySubmitClass);
    $dummySubmit.on('hover', setDummySubmitClass);
    $dummySubmit.on('click', () => {
      if (!$dummySubmit.hasClass('validated')) {
        return;
      }
      $submitButton.click();
    });

    function setDummySubmitClass() {
      if (isValidEmail($input.val())) {
        $dummySubmit.addClass('validated');
      } else {
        $dummySubmit.removeClass('validated')
      }
    }
  }

  function isValidEmail(email) {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailPattern.test(email);
  }
});